import React from "react";
import { useSelector } from "react-redux";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import AppBar from "./../../components/DefaultAppBar";
import ProfileHeader from "./ProfileHeader";

export const route = "/profile/account";

function AccountContainer() {
  const currentEstate = useSelector(({ estates }) => estates.currentEstate);

  return (
    <div>
      <AppBar position="static">
        <LocationFilterToolbar noTicketFilter />
      </AppBar>

      <ProfileHeader estate={currentEstate} />
    </div>
  );
}

AccountContainer.route = route;

export default AccountContainer;
